import React, { useState, useEffect } from "react";
import './index.scss'

const Block = ({ label, value, unit, blockClass, icon, onClick }) => {
  return (
    <div className={`block_screen flex alignItemCenter ${blockClass}`} onClick={onClick}>
      <div className="block_icon">{icon}</div>
      <div className={`alignItemCenter flexColumn ml8 ${blockClass}`}>
        <div className="flex alignItemCenter">
          <div className="block_vlaue font16 numberFont">{value || value == 0 ? value : '--'}</div>
          <div className="block_unit font12 color45 ml4">{unit}</div>
        </div>
        <div className="block_label font12 textOverFlow">{label}</div>
      </div>
    </div>
  )
}

export default Block;